import { Component } from "@angular/core";

@Component({
  selector: "app-contact-tablet",
  template: `
    <div class="first-line line">
      <div class="first-block">
        <h1>FALE COM A GENTE!</h1>
        <p>
          <span class="bold">Fale diretamente</span> com nosso Vendedor pelo
          Whatsapp!
        </p>
      </div>
      <div class="second-block">
        <app-falar-vendedor-button></app-falar-vendedor-button>
      </div>
    </div>
    <div class="divider_line"></div>
    <div class="second-line line">
      <div class="first-block">
        <h2><span class="visit">VISITE</span> NOSSA LOJA!</h2>
        <app-info-item
          class="info-item"
          icon="localization"
          label="PARNAMIRIM"
          link="https://www.google.com.br/maps/place/Sonora+Musical/@-5.9160068,-35.2748641,19z/data=!4m15!1m8!3m7!1s0x7b25710bca19c79:0x51a3d98e1373c677!2sR.+Dorothy+de+Moura+Lima,+290+-+Santos+Reis,+Parnamirim+-+RN,+59141-100!3b1!8m2!3d-5.9160081!4d-35.2742204!16s%2Fg%2F11cs9j48gk!3m5!1s0x7b25710bc8e2591:0x60550adcc82f1356!8m2!3d-5.916064!4d-35.2741853!16s%2Fg%2F11clgj6htg?entry=ttu&g_ep=EgoyMDI1MDUyMS4wIKXMDSoASAFQAw%3D%3D"
          [opacity]="0.5"
        ></app-info-item>
        <app-info-item
          icon="phone"
          class="info-item"
          class="space-right"
          label="(84) 98684.5330"
          link="https://wa.me/5584986845330?text=%C2%A9%20Sonora%20Musical%0A%3E%3E%0AOl%C3%A1!%20Obrigado%20pelo%20contato!%20Como%20posso%20ajudar%20voc%C3%AA%3F"
          [opacity]="0.5"
        ></app-info-item>
        <app-info-item
          icon="instagram"
          class="info-item"
          label="SIGA-NOS"
          link="https://www.facebook.com/sonoramusical"
        ></app-info-item>
      </div>
      <div class="second-block">
        <h2>NOSSOS PRODUTOS</h2>
        <app-lista-servicos></app-lista-servicos>
      </div>
    </div>
    <div class="bottom">
      <p>®  Copyright 2025 Sonora Musical. Todos os direitos reservados.</p>
      <a target="_blank" href="https://silvanohebert.com.br/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.455 13">
          <path
            d="M8.459,3.347H6.939v3.07l-4.2-2.572a.628.628,0,0,1-.249-.5V2.489H4.727V0H2.018A2.012,2.012,0,0,0,0,2.019V8.243L2.488,9.764v-3.1l4.23,2.572a.616.616,0,0,1,.249.47v.111a.685.685,0,0,1-.691.691H4.727V13H7.436a2.03,2.03,0,0,0,2.018-2.019V4.315A1,1,0,0,0,8.459,3.347Z"
            fill="#fff"
          />
        </svg>
      </a>
    </div>
  `,
  styles: [
    `
      .line {
        padding: 0rem 2rem;
      }

      .first-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2.4rem 2rem;
        margin-bottom: 0.5rem;
      }

      .first-line h1 {
        font-weight: normal;
        font-size: 1.4rem;
        line-height: 1.5rem;
        letter-spacing: 0rem;
      }

      .first-line p {
        font-size: 0.88rem;
        font-family: "Metronic Pro", sans-serif;
        font-weight: 400;
        font-style: italic;
        line-height: 1.2rem;
        margin-bottom: 0;
        margin-top: 1rem;
      }

      .first-line p .bold {
        font-family: "Metronic Pro", sans-serif;
        font-weight: bold;
        font-style: italic;
      }

      .first-line .first-block {
        width: 13rem;
        margin-top: 1rem;
      }

      .divider_line {
        height: 2px;
        margin: 0 2rem;
        background: #e7e7e7;
      }

      .second-line {
        padding: 2.4rem 2rem;
        padding-bottom: 0;
        margin-bottom: 1rem;
        display: flex;
        justify-content: space-between;
      }

      .second-line h2 {
        font-weight: normal;
        font-size: 1rem;
        line-height: 1.1rem;
        letter-spacing: 0rem;
        margin-bottom: 1rem;
      }

      .second-line h2 .visit {
        color: #f27c00;
      }

      .second-line app-info-item {
        display: block;
        margin-bottom: 1.38rem;
      }

      .second-line .first-block h2 {
        margin-bottom: 1.7rem;
      }

      .second-line .second-block {
        width: 13rem;
      }

      .bottom {
        padding: 0rem 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .bottom p {
        font-family: "Metronic Pro", sans-serif;
        font-size: 0.5rem;
        line-height: 0.6rem;
        margin: 0;
        color: #C4C4C4;
      }

      .bottom a {
        align-self: flex-end;
      }

      .bottom svg {
        display: block;
        width: 0.42rem;
      }

      .bottom svg path {
        fill: #000000;
      }

      // .component-wrapper {
      //   // height: 100vh;
      //   // display: flex;
      //   // flex-direction: column;
      //   // align-items: center;
      //   // justify-content: center;
      // }

      // app-falar-vendedor-button {
      //   width: 100%;
      // }

      // .component-wrapper p {
      //   font-family: "Metronic Pro", sans-serif;
      //   font-size: 0.5rem;
      //   line-height: 0.6rem;
      //   text-align: center;
      // }

      // .component-wrapper p .bold {
      //   font-family: "Metronic Pro", sans-serif;
      //   font-weight: bold;
      //   font-size: 0.5rem;
      // }
    `,
  ],
})
export class ContactTabletComponent {}
